import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader, Button, BUTTON_SIZES, BUTTON_VARIANTS,Dialog, Toast, TOAST_POSITIONS, TOAST_VARIANTS, TOAST_VISIBILITY_DURATIONS } from 'cdk-radial';
import Page from '../../../page';
import BackButton from '../../BackButton';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../config/uiFactory.config';
import './DAABSubscriptions.scss';
import {
  getSubscriptionsData,
  sendUnsubscribeRequest,
  setRemoveLocationsApiName,
} from '../../../../redux/connectedComponent/daabSubscriptions/daabSubscriptions.slice';
import { resetunSubscribeRequestSentFlag } from '../../../../redux/connectedComponent/daabSubscriptions/daabSubscriptions.slice';
import { LocationsTable } from './LocationsTable';
import styled from 'styled-components';
import { PAGE_TITLE } from '../../../../constants/constants';
import { trackPageView, PAGE_SECTIONS, PAGE_SUBSECTIONS } from '../../../../utils/gtm';

const StyledDialog = styled(Dialog)`
max-height: 524px;
z-index:10000 !important;
width:808px;
`;
export const handleCompleteRemoveLocation = ({
  removeLocationsList,
  solutionData,
  id,
  orgId,
  type,
  removeLocationsEntityIdArray,
  dispatch,
  token,
}) => {
  const { id: appId, name: appName } = solutionData;
  if (removeLocationsList && removeLocationsList.length > 0) {
    const payload = {
      appId,
      appName,
      entityIdList: [...removeLocationsEntityIdArray],
      api: { id, orgId, type },
    };
    dispatch(sendUnsubscribeRequest({ payload, token }));
  }
};


export const RemoveSubscriptionLocations = (props) => {
  const { id, name, type, orgId, solutionData, webhookUrl, bundleLocations, bundleId } = props;
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = state?.loginDetailsSlice;
  const {
    fetchingSubscriptions,
    errorFetchingSubscriptions,
    unSubscribeRequestSent,
    sendingUnsubscribeRequest,
    errorSendingUnsubscribeRequest
  } = state?.daabSubscriptionsSlice;
  const { prevScreen } = state.uiFactorySlice;
  const [removeLocationsList, setRemoveLocationsList] = useState([]);
  const [showDialog,setShowDialog]=useState(false);
  const [removeLocationsEntityIdArray,setRemoveLocationsEntityIdArray]=useState([]);

  const onBack = () => {
      dispatch(setScreen({ screen: prevScreen, additionalData: { id, type, webhookUrl, name, orgId, bundleId, bundleLocations } }));
    };

  const handleRemoveLocation = (list) => {
    let entityIds=list.map(item => item.entityId);
    setRemoveLocationsEntityIdArray(entityIds);
    setRemoveLocationsList(list);
  };

  useEffect(() => {
    const isBundle = !!(bundleId || (bundleLocations && bundleLocations.length > 0));
    trackPageView({
      page_section: PAGE_SECTIONS.MY_APIS,
      page_subsection: isBundle
        ? PAGE_SUBSECTIONS.MANAGE_BUNDLE_LOCATIONS
        : PAGE_SUBSECTIONS.MANAGE_API_LOCATIONS,
    });
  }, [bundleId, bundleLocations]);

  useEffect(() => {
    const { id: appId } = solutionData;
    dispatch(
      getSubscriptionsData({
        solutionId: appId,
        apiId: id,
        apiType: type,
        token,
      })
    );
    dispatch(setRemoveLocationsApiName(name));
  }, []);

  useEffect(() => {
    if (removeLocationsList.length > 0) {
      dispatch(setScreen({ screen: screens.MY_APIS }));
    }
  }, [unSubscribeRequestSent]);

  return (
    <>
    <Page pageHeader={PAGE_TITLE.MY_APIS}>
      <BackButton onBack={onBack} />
      <div className="main-menu-container">
        <div className="add-locations-page">
          <section className="add-locations-page-header-container">
            <div className="heading">Remove Locations for {name}</div>
          </section>
          {fetchingSubscriptions ? (
            <div className="add-locations-loader">
              <Loader />
            </div>
          ) : errorFetchingSubscriptions ? (
            <div className="add-locations-loader">
              Error while fetching data, try again after sometime.
            </div>
          ) : (
            <>
              <section className='locations-table-section'>
                <LocationsTable
                  selectedApiToManageLocation={{ id, name, type, bundleId }}
                  isRemoveLocations={true}
                  handleRemoveLocation={handleRemoveLocation}
                  bundleLocations={bundleLocations}
                  bundleId={bundleId}
                />
              </section>
              <div className="daab-remove-location-footer">
                <Button
                  dataTestId="remove-locations-button"
                  isDisabled={removeLocationsEntityIdArray.length === 0}
                  size={BUTTON_SIZES.STANDARD}
                  text={'Remove'}
                  variant={BUTTON_VARIANTS.PRIMARY}
                  onClick={() =>{ setShowDialog(true); dispatch(resetunSubscribeRequestSentFlag());}}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Page>
     <StyledDialog
     buttonsProps={[
       {
         id: 'dialog-7-action-1',
         className: 'remove-location-dialog-cancel-button',
         onClick: () => setShowDialog(false),
         text: 'Cancel',
         variant: BUTTON_VARIANTS.SECONDARY,
       },
       {
         id: 'dialog-7-action-2',
         onClick: () => handleCompleteRemoveLocation({
          removeLocationsList,
          solutionData,
          id,
          orgId,
          type,
          removeLocationsEntityIdArray,
          dispatch,
          token,
        }),
         text: sendingUnsubscribeRequest? (
           <div className='remove-location-button'>
           <Loader className='removing-locations-loader' /> 
             <span className='removing-locations-text' >
              Removing...
              </span>
           </div>
         ) : (
           <div className='remove-location-button'>
             Remove
           </div>
         ),
         variant: BUTTON_VARIANTS.PRIMARY,
         isDisabled: sendingUnsubscribeRequest?true:false,
       },
     ]}
     id="dialog-7"
     isOpen={showDialog && !errorSendingUnsubscribeRequest}
     onClose={() => setShowDialog(false)}
     title={
       <div className="remove-location-dialog-header-wrapper">
         <div className="remove-location-dialog-header">
           Remove Locations
         </div>
         <div className="remove-location-dialog-header-description">
           These locations will be disconnected from {name}
         </div>
         <div className="remove-location-dialog-header-warning-text">
           Warning: This cancels all API integrations and may cause
           interruptions.
         </div>
       </div>
     }
     dataTestId="remove-location-dialog"
   >
     {removeLocationsList.map((location, index) => {
  return (
    <div 
      className={`remove-location-dialog-content-wrapper ${
        index === removeLocationsList.length - 1 ? 'last-item' : ''
      }`}
      key={index} 
    >
      <div className='remove-location-dialog-content-location'>{location?.location}</div>
      <div className='remove-location-dialog-content-address'>{location?.address}</div>
      <div className='remove-location-dialog-content-address'>CMF {location?.cmfNumber}</div>
    </div>
  );
})}
   </StyledDialog>
   {errorSendingUnsubscribeRequest && (
           <Toast
             variant={TOAST_VARIANTS.NEGATIVE}
             content={`Your request could not be processed. Please try again later.`}
             id={'contact-provider-edit-plan-toast'}
             onVisibilityDurationEnd={() => {
               dispatch(resetunSubscribeRequestSentFlag())
               setShowDialog(false);
             }}
             position={TOAST_POSITIONS.FIXED}
             visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
             style={{ marginTop: '64px' }}
           />
         )}
   </>
  );
};
